/**
 * One socket for the open tab. Screens subscribe; the connection stays up
 * while at least one listener remains, and reconnects after a drop.
 */

const listeners = new Set();
let socket = null;
let retry = null;

function token() {
  try {
    return localStorage.getItem('accessToken') || '';
  } catch {
    return '';
  }
}

function connect() {
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) return;
  const access = token();
  if (!access || !listeners.size) return;
  const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
  let next;
  try {
    next = new WebSocket(`${protocol}//${location.host}/ws?token=${encodeURIComponent(access)}`);
  } catch {
    schedule();
    return;
  }
  socket = next;
  next.onmessage = (event) => {
    let data;
    try {
      data = JSON.parse(event.data);
    } catch {
      return;
    }
    for (const fn of listeners) fn(data);
  };
  next.onclose = () => {
    if (socket === next) socket = null;
    schedule();
  };
  next.onerror = () => {};
}

function schedule() {
  if (retry || !listeners.size) return;
  retry = setTimeout(() => {
    retry = null;
    connect();
  }, 5000);
}

/** @param {(data: { event?: string, data?: object }) => void} fn */
export function subscribe(fn) {
  listeners.add(fn);
  connect();
  return () => {
    listeners.delete(fn);
    if (!listeners.size && socket) {
      socket.close();
      socket = null;
    }
  };
}

/** True when the shared chat socket is open (S60b polling fallback). */
export function isSocketOpen() {
  return !!(socket && socket.readyState === WebSocket.OPEN);
}

/** @param {string} groupId */
export function sendTyping(groupId) {
  if (!socket || socket.readyState !== WebSocket.OPEN || !groupId) return;
  socket.send(JSON.stringify({ event: 'typing', group_id: groupId }));
}
